import { Amplify, Auth, API } from 'aws-amplify';
import awsConfig from './aws-exports';

Amplify.configure(awsConfig);

console.log(awsConfig);

console.log(Auth.configure());

export { Auth, API }